import React, { useContext, useState } from 'react';
import { Text } from 'react-native';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';

import AuthContext from 'app/src/contexts/AuthContext';
import {
  Card,
  AssetCardUpperContainer,
  AssetCardImage,
  AssetCardDetails,
  AssetCardDetailRow,
  CardBoldText,
  AssetCardSaleInfo,
  CardButtonGroup
} from 'app/src/elements';
import * as colors from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';

const AssetCard = ({ saleAsset, asset }) => {
  const { user } = useContext(AuthContext);
  if (!asset) { asset = saleAsset.asset };

  const photoUrl = asset.photos[0]?.url || asset.soarrPhotoUrls[0];
  return (
    <Card>
      <AssetCardUpperContainer>
        <AssetCardImage>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt={asset?.stockNumber}
              style={{maxHeight: 80}}
            />
          )  : (
            <FontAwesomeIcon
              icon={faCamera}
              size='2xl'
              style={{color: colors.iconGray}}
            />
          )}
        </AssetCardImage>
        <AssetCardDetails>
          <CardBoldText>
            <Link to={`/assets/${asset.id}`}>
              {asset.name} {asset.type}
            </Link>
          </CardBoldText>
          <AssetCardDetailRow>
            <CardBoldText style={{flex: 3}}>
              {asset.stockNumber} | {asset.vin}
            </CardBoldText>
            <CardBoldText style={{flex: 2}}>
              {asset.clientNumber && (
                <Text>
                  {user?.seller.clientNumberLabel}{': '}
                  {asset?.clientNumber}
                </Text>
              )}
            </CardBoldText>
          </AssetCardDetailRow>
          <AssetCardSaleInfo>
            <Text style={{flex: 3}}>
              Sale Date: {moment(saleAsset?.sale?.saleOn).format('M-DD-YY')}
            </Text>
            <Text style={{flex: 2}}>
              Run #: {saleAsset?.lotNumber}
            </Text>
          </AssetCardSaleInfo>
        </AssetCardDetails>
      </AssetCardUpperContainer>

    </Card>
  )
}

export default AssetCard;
